import { render, staticRenderFns } from "./linkVideo.vue?vue&type=template&id=1cfcfba2&scoped=true&"
import script from "./linkVideo.vue?vue&type=script&lang=js&"
export * from "./linkVideo.vue?vue&type=script&lang=js&"
import style0 from "./linkVideo.vue?vue&type=style&index=0&id=1cfcfba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfcfba2",
  null
  
)

export default component.exports